const Scorer = ({ data }) => {
  const { titulo, singularid } = data
  return (
    <div className="max-w-6xl mx-auto">
      <p className="text-3xl text-blue">{titulo}</p>
      {singularid.map((id, idx) => (
        <>
          <p
            className={`relative truncate text-3xl text-blue font-bold z-10 ${
              idx !== 0 ? 'lg:-mt-[300px]' : 'mt-20'
            }`}
          >{`Partit ${idx + 1}`}</p>
          <div className="relative block mt-5 h-[250px] lg:h-[700px] overflow-hidden bg-white">
            <iframe
              src={`https://app.singular.live/output/${id.texto}?aspect=16:9`}
              className="absolute top-0 bottom-0 left-0 w-full h-full"
            ></iframe>
          </div>
        </>
      ))}
    </div>
  )
}

export default Scorer
